import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PaymentGatewayService {
  private baseUrl = environment.baseUrl + environment.accountUrl;
  private tenantUrl = environment.baseUrl + environment.accountUrl;
  private countryBaseUrl = environment.countryBaseUrl;

  constructor(private http: HttpClient) {}

  configurePaymentGateway(gatewayData: any): Observable<any> {
    return this.http.post(`${this.baseUrl}payment-gateway/tenant`, gatewayData);
  }

  getConfiguredGateways(): Observable<any> {
    return this.http.get(`${this.baseUrl}payment-gateway/tenant`);
  }

  deleteConfiguredGateway(gatewayId: any): Observable<any> {
    return this.http.delete(
      `${this.baseUrl}payment-gateway/tenant/${gatewayId}`,
    );
  }

  getCountryGateways(countryCode: string): Observable<any> {
    return this.http.get(
      `${this.countryBaseUrl}country-data/api/payment-gateways/country/${countryCode}/names`,
    );
  }

  setDefaultGateway(gatewayId: string): Observable<any> {
    return this.http.post(
      `${this.baseUrl}payment-gateway/tenant/${gatewayId}/set-default`,
      {},
    );
  }

  editGatewayById(id: string, payload: any): Observable<any> {
    return this.http.put(
      `${this.tenantUrl}tenant/payment-gateway/${id}`,
      payload,
    );
  }

  updateGatewayById(id: string, payload: any): Observable<any> {
    return this.http.put(
      `${this.tenantUrl}tenant/payment-gateway/${id}`,
      payload,
    );
  }
}
